import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { format } from 'date-fns';
import { RediscoveryApplication } from 'talent_matching/types';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix(
  'talent_matching.rediscovery.table.application_history'
);

type LatestApplicationHistoryCellProps = {
  application: RediscoveryApplication;
  userDateFormat?: string;
};

const LatestApplicationHistoryCell = ({
  application,
  userDateFormat = 'month_day_year',
}: LatestApplicationHistoryCellProps) => {
  let dateFormat: string;
  switch (userDateFormat) {
    case 'day_month_year':
      dateFormat = 'd LLLL yyyy';
      break;
    case 'year_month_day':
      dateFormat = 'yyyy LLLL d';
      break;
    default:
      dateFormat = 'LLLL d, yyyy';
  }

  const formatDate = (date: string) => {
    return format(new Date(date), dateFormat);
  };

  return (
    <Stack spacing={0.5} sx={{ padding: 1, paddingLeft: 0 }}>
      <SecondaryBody>{application.hiringPlanName}</SecondaryBody>
      {application.rejectedOn && (
        <SecondaryBody>
          {t('rejected_on', { date: formatDate(application.rejectedOn) })}
        </SecondaryBody>
      )}
      {application.rejectionReason && (
        <SecondaryBody>
          <SecondaryBody metadata as="span">
            {t('reason_label')}
          </SecondaryBody>{' '}
          {application.rejectionReason}
        </SecondaryBody>
      )}
      {application.currentStage && (
        <SecondaryBody>
          <SecondaryBody metadata as="span">
            {t('stage_label')}
          </SecondaryBody>{' '}
          {application.currentStage.name}
        </SecondaryBody>
      )}
    </Stack>
  );
};

export default LatestApplicationHistoryCell;
